import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import { getSprinkles } from './sprinkles';
import { componentList } from './helpers/componentList';
import { getEnvReducer } from './reducers/shared/sharedReducer';

export const getStore = async () => {
    const envReducer = await getEnvReducer();
    const reducersObject = getSprinkles().reduce((reducers, { componentName }) => {
        const Component = componentList[componentName];
        if (Component && Component.reducers) {
            return { ...reducers, ...Component.reducers };
            // return combineReducers({ ...reducers, ...Component.reducers });
        }
    
        return reducers;
    }, { Env: envReducer });

    const combinedReducers = combineReducers(reducersObject);
    return createStore(combinedReducers, composeWithDevTools(applyMiddleware(thunkMiddleware)));
}
